import React from "react"
import { useQuery } from "react-query"
import moment from "moment"
import useUser from "../../../hooks/useUser"
import { getAlertesCounterDashboardRequest } from "../core/_requests"
import { IGetAlertesCounterDashboardResponseModel } from "../core/_models"
import DashboardAlertesConsultantAvecDocsEmbaucheNonEnvoyesListing from "./consultantsAvecDocsEmbaucheNonEnvoyes/DashboardAlertesConsultantAvecDocsEmbaucheNonEnvoyesListing"
import StaffDocsEmbaucheNonEnvoyesSection from "./staffAvecDocsEmbaucheNonEnvoyes/StaffDocsEmbaucheNonEnvoyesSection"

type Tab = "consultants" | "staff"

/**
 * Alerte « documents d'embauche non envoyés » : fusionne, dans une même interface, les consultants et le staff.
 * L'onglet Staff n'est visible que pour les utilisateurs disposant d'un droit de consultation staff.
 */
const DocumentsEmbaucheNonEnvoyesListing = () => {
     const { canViewStaff } = useUser()
     const staffVisible = canViewStaff()
     const [tab, setTab] = React.useState<Tab>("consultants")

     // Compteurs des deux onglets (source canonique : le compteur d'alertes du tableau de bord).
     const countersQuery = useQuery<IGetAlertesCounterDashboardResponseModel>("REACT_QUERY_KEY_DOCS_EMBAUCHE_TAB_COUNTERS", async () =>
          getAlertesCounterDashboardRequest({
               dateConsultantsMissionsExpiredOuArrivantToExpiration: moment().format("YYYY-MM-DD"),
               dateConsultantsPeriodesEssaiExpiredOuArrivantToExpiration: moment().format("YYYY-MM-DD"),
               dateClientPropalsExpiredOuArrivantToExpiration: moment().format("YYYY-MM-DD"),
          }).then(r => r.data)
     )
     const consultantsCount = countersQuery.data?.consultantsAvecDocsEmbaucheNonEnvoyes
     const staffCount = countersQuery.data?.staffAvecDocsEmbaucheNonEnvoyes

     const countBadge = (n?: number) =>
          n === undefined ? null : <span className={`badge badge-circle badge-sm ms-2 ${n > 0 ? "badge-danger" : "badge-light"}`}>{n}</span>

     return (
          <>
               <ul className="nav nav-tabs nav-line-tabs mb-5 fs-6">
                    <li className="nav-item">
                         <button className={`nav-link d-inline-flex align-items-center ${tab === "consultants" ? "active" : ""}`} onClick={() => setTab("consultants")} type="button">
                              <i className="fas fa-user-tie me-2" /> Consultants {countBadge(consultantsCount)}
                         </button>
                    </li>
                    {staffVisible && (
                         <li className="nav-item">
                              <button className={`nav-link d-inline-flex align-items-center ${tab === "staff" ? "active" : ""}`} onClick={() => setTab("staff")} type="button">
                                   <i className="fas fa-users me-2" /> Staff {countBadge(staffCount)}
                              </button>
                         </li>
                    )}
               </ul>

               {/* Consultants : composant existant (monté en permanence pour conserver ses filtres) */}
               <div className={tab === "consultants" ? "" : "d-none"}>
                    <DashboardAlertesConsultantAvecDocsEmbaucheNonEnvoyesListing />
               </div>

               {staffVisible && tab === "staff" && (
                    <div className="card">
                         <div className="card-body">
                              <StaffDocsEmbaucheNonEnvoyesSection onChanged={() => countersQuery.refetch()} />
                         </div>
                    </div>
               )}
          </>
     )
}

export default DocumentsEmbaucheNonEnvoyesListing
